<template lang="pug">
div(v-if='salesRep' class='text-center text-lg')
  p(class='font-bold text-2xl') {{ salesRep.name }}
  p {{ salesRep.title }}
  p(class='font-bold')
    span(v-if='isARE') A.R.E. Only
    span(v-if='isARE && territoryLabel') &nbsp;-&nbsp;
    span(v-if='territoryLabel') {{ territoryLabel }}
  p
    a(v-if='phone' :href='phone.value') {{ phone.display }}
  p
    a(v-if='salesRep.email' :href='`mailto:${salesRep.email}`') {{ salesRep.email }}
</template>

<script>
export default defineNuxtComponent({
  name: 'SalesContactRep',
  props: {
    salesRep: {
      type: Object,
      required: true,
      default() {
        return null
      },
    },
  },
  computed: {
    territoryLabel() {
      const {
        'territory.state': [{ value: stateRefinement }],
      } = this.$algolia.searchContexts.salesReps.state.value.activeRefinements

      return this.salesRep.territory.find(({ state }) => state === stateRefinement)?.label
    },
    isARE() {
      return this.salesRep.department === 'A.R.E.'
    },
    phone() {
      if (!this.salesRep.phone) return null
      const formattedPhone = formatPhoneE164(this.salesRep.phone)
      return {
        display: formatPhoneDash(formattedPhone),
        value: `tel:${formattedPhone}`,
      }
    },
  },
})
</script>
